import { PRESCREENER_COMPLETION_KEYS } from 'client-portal/utils/prescreener/constants';
import { STEP_IDS } from 'client-portal/services/widget-steps';
import Super from './prescreener--base-category';

export default class RequestPrescreenerAdministrative extends Super {
  stepId = STEP_IDS.PRESCREENER_ADMINISTRATIVE;

  get getResetKeys() {
    return {
      [PRESCREENER_COMPLETION_KEYS.ADMINISTRATIVE]: false,
      [PRESCREENER_COMPLETION_KEYS.BILLING_PAYMENT]: false,
      [PRESCREENER_COMPLETION_KEYS.CLIENT_PREFERENCES]: false,
    };
  }
}
